import { useNavigator } from '@repo/toolkit/use-navigator'
import { MeetingPointIcon } from '@repo/ui/icons'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { getTripAddress } from '../../api/trip-addresses/get-trip-address'
import { updateTripAddress } from '../../api/trip-addresses/update-trip-address'
import { ItemNotFound } from '../../components/elements/item-not-found'
import LoadingScreen from '../../components/elements/loading/loading-screen'
import UserNavBar from '../../components/elements/nav-bar'
import TripAddressForm from '../../components/pages/trip-addresses/trip-address-form'
import { mapTripAddressToInput } from '../../components/pages/trip-addresses/utils'
import { Paths } from '../../lib/constants/path'
import { updateButtonsConfig } from '../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../lib/utils/functions/misc.functions'
import NotFoundPage from '../common/not-found'

const TripAddressUpdatePage = () => {
  const { id } = useParams<{ id: string }>()
  const { navigate, back } = useNavigator()
  const queryClient = useQueryClient()

  if (!id || isNaN(+id)) return <ItemNotFound title="Identifiant de lieu de RDV invalide" />

  const { mutateAsync } = useMutation({
    mutationFn: updateTripAddress,
    onError: showAxiosError,
    onSuccess() {
      queryClient.invalidateQueries({ exact: true, queryKey: ['trip-addresses', id] })
      toast.success('Lieu de RDV modifié avec succès')
    }
  })

  const { data, isLoading } = useQuery({
    queryKey: ['trip-addresses', id],
    queryFn: () => getTripAddress(+id)
  })

  if (isLoading) return <LoadingScreen />
  if (!data) return <NotFoundPage />

  return (
    <div>
      <UserNavBar title={'Modifier un lieu de RDV'} icon={MeetingPointIcon} />
      <div className={'h-4'} />
      <TripAddressForm
        defaultValues={mapTripAddressToInput(data)}
        buttonsConfig={updateButtonsConfig({
          onCancel: () => back(Paths.TRIP_ADDRESS_LIST_PAGE),
          onUpdate: (values) => mutateAsync({ id: data.id, ...values }),
          onUpdateThenCreate: async (values) => {
            await mutateAsync({ id: data.id, ...values })
            navigate(Paths.TRIP_ADDRESS_CREATE_PAGE)
          },
          onUpdateThenList: async (values) => {
            await mutateAsync({ id: data.id, ...values })
            navigate(Paths.TRIP_ADDRESS_LIST_PAGE, { replace: true })
          }
        })}
      />
    </div>
  )
}
export default TripAddressUpdatePage
